import { generateUtilityClasses } from '@mui/material';

export const generateClasses = <TClasses = unknown>(prefix: string, componentName: string, slots: string[]) => {
	return generateUtilityClasses<string>(`${prefix}${componentName}`, slots) as Record<keyof TClasses, string>;
};
